import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getClassMeets } from '../../api/class';

const Meets = ({ cid, user }) => {
    const [meets, setMeets] = useState([])
    const [loading, setLoading] = useState(true)


    useEffect(() => {
        loadMeets()
    }, [])

    const loadMeets = () => {
        getClassMeets(cid)
            .then(res => {
                setMeets(res.data)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
            })
    }

    const displayDate = (date) => {
        return `${date.getDate()}/${(date.getMonth() + 1)}/${date.getFullYear()}`
    }

    return (
        <div className="my-class-meets-div">
            <div className="my-class-meets">
                {
                    loading ? <h1>loading</h1> :
                        (
                            (meets && meets.length) ? (meets.map((each, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', margin: '20px 50px', padding: '30px', border: '1px solid grey' }} className="my-classroom-meet-details">
                                    <h3>{displayDate(new Date(each.on_date))}</h3>
                                    <h3>{each.topic}</h3>
                                    <button className="btn btn-primary">More Detals</button>
                                </div>
                            ))) : ""
                        )
                }
            </div>
        </div>
    );
};

export default Meets;